module.exports = __webpack_public_path__ + "ax.no1.f82174c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ax.no1.jpg
// module id = k9r7
// module chunks = 0